import { useEffect, useState } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { get_transaction_by_id, update_transaction_by_id } from '../api/transaction_api';
import TransactionForm from './TransactionForm';

const UpdateTransactionPage = () => {
    const { beneficiary_id, transaction_id } = useParams();
    const navigate = useNavigate();
    const location = useLocation();
    const { beneficiaryName } = location.state || {};
    const [initialData, setInitialData] = useState(null);

    useEffect(() => {
        const fetchTransaction = async () => {
            try {
                const data = await get_transaction_by_id(transaction_id);
                if (data.date) {
                    data.date = new Date(data.date).toISOString().split('T')[0];
                }
                if (data.check_date) {
                    data.check_date = new Date(data.check_date).toISOString().split('T')[0];
                }
                if (Array.isArray(data.meeting_dates)) {
                    data.meeting_dates = data.meeting_dates.map((meetingDate) => new Date(meetingDate).toISOString().split('T')[0]);
                } else if (data.meeting_date) {
                    data.meeting_dates = [new Date(data.meeting_date).toISOString().split('T')[0]];
                }
                console.log(data);
                setInitialData(data);
            } catch (err) {
                console.error(err);
                alert('שגיאה בטעינת פרטי הפעולה');
            }
        };
        fetchTransaction();
    }, [transaction_id]);

    const handleSubmit = async (e) => {
        e.preventDefault();

        const category = e.target.category.value;
        const welfareSubcategory = e.target.welfare_subcategory?.value || null;
        const meetingDates = Array.from(e.target.querySelectorAll('input[name="meeting_dates"]'))
            .map((input) => input.value)
            .filter(Boolean);
        const meetingCount = meetingDates.length || null;

        if (category === 'סיוע ורווחה' && welfareSubcategory === 'טיפול ע"י מטפל') {
            if (!meetingCount) {
                alert('יש למלא לפחות תאריך מפגש אחד עבור טיפול ע"י מטפל');
                return;
            }
        }

        const updatedTransaction = {
            provider_name: e.target.provider_name.value,
            payment_to_supplier: e.target.payment_to_supplier?.value || null,
            payment_method: e.target.payment_method.value,
            category,
            welfare_subcategory: welfareSubcategory,
            meeting_count: meetingCount,
            meeting_dates: meetingDates,
            amount: e.target.amount.value,
            date: e.target.date.value,
            comments: e.target.comments.value,
            check_date: e.target.check_date?.value || null,
            check_number: e.target.check_number?.value || null,
            check_amount: e.target.check_amount?.value || null,
        };
        try {
            await update_transaction_by_id(transaction_id, updatedTransaction);
            alert('הפעולה עודכנה בהצלחה!');
            navigate(`/beneficiaries/${beneficiary_id}`);
        } catch (err) {
            console.error(err);
            alert('עדכון הפעולה נכשל');
        }
    };

    if (!initialData) return <div>טוען...</div>;

    return (
        <>
            <div className="top-buttons-container">
                {/* כפתור חזרה דף אחורה - עם חץ */}
                <button className="round-nav-btn" onClick={() => navigate(-1)} title="חזרה">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#EF5DA8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <line x1="5" y1="12" x2="19" y2="12"></line>
                        <polyline points="12 5 19 12 12 19"></polyline>
                    </svg>
                </button>
                {/* כפתור דף הבית - עם בית */}
                <button className="round-nav-btn" onClick={() => navigate('/main_screen')} title="דף הבית">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#EF5DA8" strokeWidth="2">
                        <path d="M12 3L2 12h3v7h4v-5h6v5h4v-7h3L12 3z" />
                    </svg>
                </button>
            </div>
            <div dir="rtl" style={{ maxWidth: '500px', margin: 'auto' }}>
                <h2 style={{ color: "#150F6B", marginRight: "12%" }}>עריכת פעולה {beneficiaryName}</h2>
                <TransactionForm
                    kind="provider"
                    onSubmit={handleSubmit}
                    initialData={initialData}
                    mode="edit"
                />
            </div>
        </>
    );
};

export default UpdateTransactionPage;
